import 'polyfill-nodelist-foreach'
import { Cart } from './component/checkout/cart';
import { Main } from './component/checkout/main';
import { Validation } from './utilities/validation';
import { CheckoutRating } from './component/checkout/checkout-rating';


let cart = new Cart();
let main = new Main();
let validation = new Validation();

cart.init();
main.init();
validation.init();
new CheckoutRating().init();